import { AI_TOOLS, getAIToolIcon, getIsComingSoonTool } from '../AIStudioUtils'
import { BLUE_100, BLUE_600, GRAY_100, GRAY_400, GRAY_500, GRAY_700, GRAY_900, WHITE } from 'constants/styling/upbrandingTheme'
import { Box, Typography } from '@mui/material'

import { MUIBadge } from 'components/common/MUIBadge'
import React from 'react'
import Stack from '@mui/material/Stack'
import { useClientAIStudio } from './ClientAIStudio.context'
import { useTranslation } from 'react-i18next'

/**
 * @component
 *
 * @example
 * <AIToolsSection />
 */
export const AIToolsSection: React.FC = () => {
  const { t } = useTranslation(['ai_studio_editing'])

  const {
    selectedAIFeature,
    setIsConfirmationOpen,
    setNewTool,
    handleAIFeatureChange,
    isExportBetweenEditingCategories,
  } = useClientAIStudio()

  return (
    <Stack>

      <Typography variant="text-sm" fontWeight="600" color={GRAY_900}>{t('ai_tools_title')}</Typography>

      <Stack marginTop={1.6} gap={.8} flexDirection="column" flexWrap="wrap">
        {Object.values(AI_TOOLS).map((tool: AI_TOOLS) => {
          const isSelectedTool = selectedAIFeature === tool
          const isComingSoonTool = getIsComingSoonTool(tool)

          return (
            <Box
              key={tool}
              onClick={() => {
                if (!isComingSoonTool) {
                  if (isExportBetweenEditingCategories(tool)) {
                    setNewTool(tool)
                    setIsConfirmationOpen(true)
                  } else {
                    handleAIFeatureChange(tool)
                  }
                }
              }}
              sx={{
                backgroundColor: isComingSoonTool ? GRAY_100 : isSelectedTool ? BLUE_100 : WHITE,
                padding: '1.4rem 1.8rem',
                borderRadius: 1.6,
                border: '1px solid',
                borderColor: isSelectedTool ? BLUE_600 : GRAY_400,
                color: isComingSoonTool ? GRAY_500 : isSelectedTool ? GRAY_900 : GRAY_700,
                textAlign: 'left',
                fontWeight: isSelectedTool ? '600' : '400',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: isSelectedTool ? BLUE_100 : GRAY_100,
                  fontWeight: isComingSoonTool ? '400' : '600',
                  color: isComingSoonTool ? GRAY_500 : GRAY_900,
                  cursor: isComingSoonTool ? 'not-allowed' : 'pointer',
                },
              }}
            >
              <Stack gap={1.2} flexDirection="row" alignItems="center" marginLeft={.5}>

                {getAIToolIcon(tool)}

                <Typography variant="text-xs">{t(`ai_tools.${tool}`)}</Typography>

                {isComingSoonTool &&
                  <Stack marginLeft="auto">
                    <MUIBadge label={t('common:coming_soon')} size="xs" color="coral" />
                  </Stack>
                }

              </Stack>
            </Box>
          )
        })}
      </Stack>

    </Stack>
  )
}
